import { FormatListNumberedIcon } from './FormatListNumberedIcon';

/**
 * author: Google
 * id EFEB4AB3-780B-4C2D-B673-36BB0A4FE0B2
 * name format-list-numbered
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-numbered.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListNumbersIcon = FormatListNumberedIcon;
export default FormatListNumbersIcon